import { render, staticRenderFns } from "./DeleteSchemeModal.vue?vue&type=template&id=6073d3c8&scoped=true"
import script from "./DeleteSchemeModal.vue?vue&type=script&lang=js"
export * from "./DeleteSchemeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073d3c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6073d3c8')) {
      api.createRecord('6073d3c8', component.options)
    } else {
      api.reload('6073d3c8', component.options)
    }
    module.hot.accept("./DeleteSchemeModal.vue?vue&type=template&id=6073d3c8&scoped=true", function () {
      api.rerender('6073d3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings/DeleteSchemeModal.vue"
export default component.exports